import * as React from 'react';
import {useEffect, useState} from 'react';
import Paper from '@mui/material/Paper';
import {Add, Autorenew, Check, Delete, Info, KeyboardArrowDown, MarkEmailRead, Markunread, PlayArrowOutlined, PriorityHigh, ReportOff, Save, Warning} from '@mui/icons-material';
import {useNavigate} from 'react-router-dom';
import {useTitle} from '../dashboard/TitleContext';
import notificationService from '../../services/NotificationService';
import TablePagination from "@mui/material/TablePagination";
import {Accordion, AccordionDetails, AccordionSummary, Box, Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid2 as Grid, Icon, InputLabel, Link, MenuItem, OutlinedInput, Select, TextField, Tooltip} from "@mui/material";
import {useSnackbar} from "../../util/SnackbarProvider";
import filterService from "../../services/NotificatioFilterService";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import {PRIORITIES, STATUSES} from "../../util/Const";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import projectTaskService from "../../services/ProjectTaskService";
import authService from "../../services/AuthService";
import {limit} from "../../util/StringUtils";
import taskService from "../../services/TaskService";
import projectService from "../../services/ProjectService";


const LOCAL_STORAGE_ITEM_NAME = "notifications-rows-per-page"
const LOCAL_STORAGE_SEARCH_PARAMS = "notifications-search-params"
const NOTIFICATION_VARIANTS = {
    NEW_TASK_CHAT_MESSAGE: "Feladat üzenet",
    ASSIGNED_TO_TASK: "Új feladat",
};

export default function Notifications() {

    useTitle([{name: 'Értesítések'}])

    const [tableData, setTableData] = useState({
        page: 0,
        rowsPerPage: localStorage.getItem(LOCAL_STORAGE_ITEM_NAME) || 25,
        totalCount: 0
    })
    const [searchParams, setSearchParams] = useState(JSON.parse(localStorage.getItem(LOCAL_STORAGE_SEARCH_PARAMS)))
    const [expanded, setExpanded] = useState(true);
    const {sendAlertMessage} = useSnackbar()
    const currentUser = authService.getCurrentUser()

    useEffect(() => {
        retrieveNotifications()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableData.page, tableData.rowsPerPage, searchParams]);

    const retrieveNotifications = () => {
        notificationService.findAllForCurrentUser(buildQueryParams())
            .then(response => setTableData((prev) => ({
                ...prev,
                totalCount: response.totalElements,
                rows: response.content
            })))
            .catch(() => 'Értesítések lekérése sikertelen!', 'error')
    }

    function buildQueryParams() {
        return {
            page: tableData.page,
            size: tableData.rowsPerPage,
            ...(searchParams?.type && {type: searchParams.type}),
            ...(searchParams?.variants && searchParams?.variants[0] && {variants: searchParams.variants}),
            ...(searchParams?.fromDate && {fromDate: searchParams.fromDate}),
            ...(searchParams?.toDate && {toDate: searchParams.toDate}),
            ...(searchParams?.onlyUnseen && {onlyUnseen: searchParams.onlyUnseen}),
        }
    }

    const setSeen = (id, seen, e) => {
        if (e) e.stopPropagation()
        notificationService.setSeen(id, {seen})
            .then(() => retrieveNotifications())
            .catch(() => 'Értesítés frissítése sikertelen!', 'error')
    }

    const navigate = useNavigate()

    const getUrl = (notification) => {
        console.log(notification)
        const metadata = JSON.parse(notification.metadata || "{}")
        switch (notification.variant) {
            case "NEW_TASK_CHAT_MESSAGE":
                return "/dashboard/tasks/" + metadata.taskId
            case "ASSIGNED_TO_TASK":
                return "/dashboard/tasks/" + metadata.taskId
            case "MODIFIED_TASK":
                return "/dashboard/tasks/" + metadata.taskId
            case "CREATED_TASK":
                return "/dashboard/tasks/" + metadata.taskId
            default:
                console.error("Invalid notification variant")
        }
    }

    const onSearchParamsChange = (event) => {
        const {name, value} = event.target
        setSearchParams((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const clear = () => {
        if (searchParams != null) sendAlertMessage('Szűrők alaphelyzetbe állítva', 'info')
        setSearchParams(undefined)
        setSelectedIndex(null)
    }

    useEffect(() => {
        if (searchParams) localStorage.setItem(LOCAL_STORAGE_SEARCH_PARAMS, JSON.stringify(searchParams));
        else localStorage.removeItem(LOCAL_STORAGE_SEARCH_PARAMS)
    }, [searchParams]);

    const onVariantsChange = (event, type) => {
        const {value} = event.target
        const newSelection = typeof value === 'string' ? value.split(',') : value;
        const uniqueSelection = newSelection.reduce((acc, status) => {
            const exists = acc.find(item => item === status);
            if (exists) return acc.filter(item => item !== status);
            else return [...acc, status];
        }, []);

        setSearchParams((prev) => ({
            ...prev,
            [type]: uniqueSelection,
        }));
    };

    const onChangeCheckBox = (event) => {
        const {name, checked} = event.target;
        setSearchParams((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };

    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 48 * 4.5 + 8,
                width: 250
            },
        },
    };

    function getStyles(name, statuses) {
        if (statuses == null || statuses.indexOf(name) === -1) return
        return {
            backgroundColor: "#2e7d32",
            color: "white"
        };
    }

    const [selectedIndex, setSelectedIndex] = React.useState();

    const handleListItemClick = (event, index) => {
        setSelectedIndex(index);
        setSearchParams(() => JSON.parse(filters[index].data))
    };

    const [filters, setFilters] = useState([]);
    const [isNewFilter, setIsNewFilter] = React.useState(false);
    useEffect(() => {
        retrieveFilters()
    }, []);

    function retrieveFilters() {
        filterService.search({type: 'NOTIFICATION'})
            .then(response => setFilters(response))
            .catch(error => console.error(error))
    }

    const createNewFilter = (name) => {
        filterService.create({name: name, data: JSON.stringify(searchParams), type: 'NOTIFICATION'})
            .then(() => {
                sendAlertMessage("Szűrő sikeresen létrehozva")
                retrieveFilters()
            })
            .catch(error => sendAlertMessage(error?.message || "Szűrő létrehozása sikertelen", 'error'))
    }

    const updateFilter = (name) => {
        filterService.update(filters[selectedIndex].id, {name: name, data: JSON.stringify(searchParams)})
            .then(() => {
                sendAlertMessage("Szűrő sikeresen mentve")
                retrieveFilters()
            })
            .catch(error => sendAlertMessage(error?.message || "Szűrő mentése sikertelen", 'error'))
    }

    const deleteFilter = () => {
        filterService.delete(filters[selectedIndex].id)
            .then(() => {
                sendAlertMessage("Szűrő sikeresen törölve")
                retrieveFilters()
            })
            .catch(error => sendAlertMessage(error?.message || "Szűrő törlése sikertelen", 'error'))
    }

    const [open, setOpen] = React.useState(false);
    const handleClickOpen = (isNewFilter) => {
        setOpen(true);
        setIsNewFilter(isNewFilter);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const [openNotificationDetails, setOpenNotificationDetails] = useState(false);
    const [notificationDetailsContent, setNotificationDetailsContent] = useState();
    const handleClickOpenTaskDetails = (notification) => {
        setOpenNotificationDetails(true);
        const taskId = JSON.parse(notification?.metadata || '{}')?.taskId;
        const projectTaskId = JSON.parse(notification?.metadata || '{}')?.projectTaskId;
        const projectId = JSON.parse(notification?.metadata || '{}')?.projectId;
        setNotificationDetailsContent(prev => ({...prev, type: 'TASK'}))
        retrieveTask(taskId)
        if (projectTaskId)
            projectTaskService.findById(projectTaskId)
                .then(response => setNotificationDetailsContent(prev => ({...prev, projectTask: response})))
                .catch(error => console.error(error))
        if (projectId)
            projectService.findById(projectId)
                .then(response => setNotificationDetailsContent(prev => ({...prev, project: response})))
                .catch(error => console.error(error))
    };

    function retrieveTask(taskId) {
        taskService.findById(taskId)
            .then(response => setNotificationDetailsContent(prev => ({...prev, ...response})))
            .catch(error => console.error(error))
    }


    const handleCloseTaskDetails = () => {
        setOpenNotificationDetails(false);
    };

    const tableStyle = {
        tableLayout: 'fixed',
        width: '250px',
        borderSpacing: '0px',
        '& td': {padding: '8px', border: 'none'},
        '& td:nth-child(1)': {fontWeight: 'bold'},
    }

    function getNotificationDetails() {
        switch (notificationDetailsContent?.type) {
            case 'TASK':
                return getTaskDetails()
            default:
                return null
        }
    }

    function getTaskDetails() {
        return (
            <DialogContent>
                <Table sx={tableStyle}>
                    <TableBody>
                        <TableRow>
                            <TableCell>Projekt</TableCell>
                            <TableCell>
                                <Link sx={{cursor: "pointer"}} onClick={() => navigate(`/dashboard/project-tasks/projects/${notificationDetailsContent?.project?.id}`)}>{notificationDetailsContent?.project?.name}</Link>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Fejléc</TableCell>
                            <TableCell>
                                <Link sx={{cursor: "pointer"}}
                                      onClick={() => navigate(`/dashboard/project-tasks/projects/${notificationDetailsContent?.project?.id}/tasks/${notificationDetailsContent?.projectTask?.id}`)}>{notificationDetailsContent?.projectTask?.description}</Link>
                            </TableCell>
                        </TableRow>
                        <TableRow style={{borderBottom: "1px solid gray"}}>
                            <TableCell>Feladat</TableCell>
                            <TableCell>
                                <Link sx={{cursor: "pointer"}}
                                      onClick={() => navigate(`/dashboard/tasks/${notificationDetailsContent?.id}`)}>{limit(notificationDetailsContent?.description, 30)}</Link>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Jelöltek</TableCell>
                            <TableCell>{notificationDetailsContent?.candidates?.map(u => u.name).join(", ") || '-'}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Dolgozók</TableCell>
                            <TableCell>{notificationDetailsContent?.users?.map(u => u.name).join(", ") || '-'}</TableCell>
                        </TableRow>
                        {notificationDetailsContent?.candidates?.map(c => c.id).includes(currentUser.userId) &&
                            !notificationDetailsContent?.users?.map(c => c.id).includes(currentUser.userId) &&
                            <TableRow>
                                <TableCell sx={{textAlign: "right"}} colSpan={2}>
                                    <Button variant="contained" onClick={() => {
                                        taskService.take(notificationDetailsContent?.id)
                                            .then(() => {
                                                sendAlertMessage("Feladat felvétele sikeres")
                                                retrieveTask(notificationDetailsContent?.id)
                                            })
                                            .catch(error => console.error(error))
                                    }}>Feladat Felvétele</Button>
                                </TableCell>
                            </TableRow>}
                        <TableRow style={{borderTop: "1px solid gray"}}>
                            <TableCell>Státusz</TableCell>
                            <TableCell>{STATUSES[notificationDetailsContent?.status]}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Prioritás</TableCell>
                            <TableCell>{PRIORITIES[notificationDetailsContent?.priority]}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Előrehaladás</TableCell>
                            <TableCell>{notificationDetailsContent?.progressLevel || 0} %</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </DialogContent>
        )
    }

    return (
        <div>
            <Accordion style={{margin: "0px -8px 10px 10px"}} disableGutters expanded={expanded}
                       onChange={() => setExpanded(!expanded)}>
                <AccordionSummary
                    expandIcon={<KeyboardArrowDown sx={{marginRight: "0px", height: "2em", width: "auto"}}/>} sx={{
                    minHeight: "0px",
                    fontSize: "24px",
                    fontWeight: "bold",
                    backgroundColor: "darkgray",
                    borderRadius: "4px 4px 0px 0px",
                    paddingLeft: "20px",
                    margin: "0"
                }}>
                    Keresési Feltételek
                </AccordionSummary>
                <AccordionDetails className="filter-panel">
                    <Grid container columns={10} spacing={2} padding={"10px"}>
                        <Grid size={{xs: 7}}>
                            <Grid container columns={10} spacing={2} padding={"10px"}>
                                <Grid size={{lg: 5, md: 10, xs: 20}} sx={{padding: "0px"}}>
                                    <FormControl sx={{m: 1, minWidth: 120, marginTop: "0px", marginLeft: "0px"}}
                                                 fullWidth>
                                        <InputLabel id="type-label">Típus</InputLabel>
                                        <Select
                                            variant="outlined"
                                            labelId="type-label"
                                            name="type"
                                            label="Típus"
                                            value={searchParams?.type || ""}
                                            onChange={onSearchParamsChange}
                                            sx={{textAlign: "left"}}
                                        >
                                            <MenuItem value={null}>Összes</MenuItem>
                                            <MenuItem value={'INFO'}>Információ</MenuItem>
                                            <MenuItem value={'WARNING'}>Figyelmeztetés</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{lg: 5, md: 10, xs: 20}}>
                                    <FormControl sx={{
                                        m: 1,
                                        minWidth: 120,
                                        marginTop: "0px",
                                        marginLeft: "0px"
                                    }} fullWidth>
                                        <InputLabel id="variant-label">Kategória</InputLabel>
                                        <Select
                                            labelId="variant-label"
                                            multiple
                                            value={searchParams?.variants || []}
                                            onChange={(e) => onVariantsChange(e, "variants")}
                                            label="Kategória"
                                            variant="outlined"
                                            input={<OutlinedInput id="select-multiple-chip" label="Kategória"/>}
                                            renderValue={(selected) => (
                                                <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1.0, margin: "-5px"}}>
                                                    {selected.map((value, index) => (
                                                        <Chip key={index} label={NOTIFICATION_VARIANTS[value]}/>
                                                    ))}
                                                </Box>
                                            )}
                                            MenuProps={MenuProps}
                                        >
                                            {Object.entries(NOTIFICATION_VARIANTS).map(([key, value]) => (
                                                <MenuItem key={key} value={key}
                                                          style={getStyles(key, searchParams?.statuses)}>
                                                    {value}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{lg: 5, md: 10, xs: 20}}>
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        fullWidth
                                        type="date"
                                        slotProps={{inputLabel: {shrink: true}}}
                                        label="-tól"
                                        name="fromDate"
                                        autoComplete="off"
                                        onChange={onSearchParamsChange}
                                        sx={{margin: "0px"}}
                                        value={(searchParams && searchParams.fromDate) || "-1"}
                                    />
                                </Grid>

                                <Grid size={{lg: 5, md: 10, xs: 20}}>
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        fullWidth
                                        name={"toDate"}
                                        type="date"
                                        slotProps={{inputLabel: {shrink: true}}}
                                        label="-ig"
                                        autoComplete="off"
                                        onChange={onSearchParamsChange}
                                        sx={{margin: "0px"}}
                                        value={(searchParams && searchParams.toDate) || "-1"}
                                    />
                                </Grid>

                                <Grid size={{lg: 5, md: 10, xs: 20}} style={{textAlign: "left"}}>
                                    <FormControlLabel control={<Checkbox
                                        variant="outlined"
                                        margin="normal"
                                        size="large"
                                        label="Csak Olvasatlanok"
                                        name="onlyUnseen"
                                        onChange={onChangeCheckBox}
                                        checked={searchParams?.onlyUnseen || false}
                                        value={searchParams?.onlyUnseen || false}
                                    />} label="Csak Olvasatlanok" style={{paddingTop: "0px"}}/>
                                </Grid>

                                <Grid size={{lg: 5, md: 10, xs: 20}}
                                      sx={{padding: "0px", margin: "0px 0px 10px 0px"}}>
                                    <Button onClick={clear} variant="contained" fullWidth
                                            style={{height: "56px", margin: "0px"}}>Szűrők Törlése</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={{xs: 3}}>
                            <Grid container columns={5} rowSpacing={1} columnSpacing={2}>
                                <Grid size={{xs: 3}}>
                                    <Box sx={{
                                        width: '100%',
                                        maxWidth: 360,
                                        backgroundColor: '#FFFDD0',
                                        border: "1px solid gray",
                                        borderRadius: "8px",
                                        minHeight: "218px"
                                    }}>
                                        <List component="nav" aria-label="secondary mailbox folder">
                                            {filters?.map((filter, index) => (
                                                <ListItemButton key={index} selected={selectedIndex === index} sx={{
                                                    '&.Mui-selected': {
                                                        backgroundColor: 'darkgray',
                                                        color: 'black',
                                                        '&:hover': {backgroundColor: 'gray',}
                                                    },
                                                }} onClick={(event) => handleListItemClick(event, index)}>
                                                    <ListItemText primary={filter.name}/>
                                                </ListItemButton>
                                            ))}
                                        </List>
                                    </Box>
                                </Grid>
                                <Grid size={{xs: 2}}>
                                    <Button variant="contained" color={"success"} fullWidth
                                            onClick={() => handleClickOpen(true)}
                                            style={{height: "36px", margin: "0px", position: "relative"}}>
                                        <Add style={{position: "absolute", left: 10}}/>
                                        Új
                                    </Button>
                                    <Button variant="contained" fullWidth onClick={() => handleClickOpen(false)}
                                            style={{height: "36px", marginTop: "10px", position: "relative"}}
                                            disabled={selectedIndex == null}>
                                        <Save style={{position: "absolute", left: 10}}/>
                                        Mentés
                                    </Button>
                                    <Button variant="contained" color={"error"} fullWidth onClick={deleteFilter}
                                            style={{height: "36px", marginTop: "10px"}}
                                            disabled={selectedIndex == null}>
                                        <Delete style={{position: "absolute", left: 10}}/>
                                        Törlés
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            {tableData.rows?.map((notification, index) => (
                <Paper key={index} sx={{
                    width: '100%',
                    overflow: 'hidden',
                    backgroundColor: notification.type === 'INFO' ? "#A3C8ED" : "#FFFDD0",
                    margin: "10px",
                    cursor: "pointer",
                    outline: notification.seen ? "" : "3px solid gold"
                }}
                       onClick={() => {
                           setSeen(notification.id)
                           navigate(getUrl(notification))
                       }}

                >
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "10px",
                        whiteSpace: "pre-line"
                    }}>
                        <div style={{display: 'inline-flex'}}>
                            <span onClick={(e) => {
                                e.stopPropagation()
                                setSeen(notification.id)
                                if (JSON.parse(notification.metadata).taskId != null)
                                    handleClickOpenTaskDetails(notification)
                                else navigate(getUrl(notification))
                            }}>
                                {notification.type === 'INFO' ?
                                    <Info sx={{marginRight: "10px"}}/>
                                    : <Warning sx={{marginRight: "10px"}}/>
                                }
                            </span>
                            <Tooltip title={STATUSES[notification.data?.status]}>
                                {(() => {
                                    switch (notification.data?.status) {
                                        case 'NOT_STARTED':
                                            return <PlayArrowOutlined sx={{marginRight: "10px"}}/>
                                        case 'IN_PROGRESS':
                                            return <Autorenew sx={{marginRight: "10px"}}/>
                                        case 'DONE':
                                            return <Check sx={{marginRight: "10px"}}/>
                                        default:
                                            return <Icon sx={{marginRight: "10px"}}/>;
                                    }
                                })()}
                            </Tooltip>
                            <Tooltip title={PRIORITIES[notification.data?.priority]}>
                                {(() => {
                                    switch (notification.data?.priority) {
                                        case 'EXTRA_IMPORTANT':
                                            return <span style={{position: "relative"}}>
                                            <PriorityHigh sx={{color: "red", position: "absolute", left: "-3px"}}/>
                                            <PriorityHigh sx={{color: "red", position: "absolute", left: "3px"}}/>
                                                <Icon sx={{marginRight: "10px"}}/>
                                        </span>
                                        case 'IMPORTANT':
                                            return <PriorityHigh sx={{marginRight: "10px", color: "red"}}/>
                                        case 'NORMAL':
                                            return <Icon sx={{marginRight: "10px"}}/>;
                                        case 'NOT_IMPORTANT':
                                            return <ReportOff sx={{marginRight: "10px"}}/>
                                        default:
                                            return <Icon sx={{marginRight: "10px"}}/>;
                                    }
                                })()}
                            </Tooltip>
                            <Tooltip title={notification?.seen ? "Megtekintve" : "Olvasatlan"}>
                                {notification?.seen ?
                                    <MarkEmailRead sx={{marginRight: "10px"}} onClick={(e) => setSeen(notification.id, false, e)}/> :
                                    <Markunread sx={{marginRight: "10px"}} onClick={(e) => setSeen(notification.id, true, e)}/>}
                            </Tooltip>
                            {notification.message}
                        </div>
                        <div>
                            {notification.createdAt}
                        </div>
                    </div>
                </Paper>
            ))
            }
            <Paper sx={{width: '100%', overflow: 'hidden', margin: "10px"}}>
                <TablePagination
                    rowsPerPageOptions={[3, 10, 25, 50]}
                    component="div"
                    count={tableData.totalCount}
                    rowsPerPage={parseInt(tableData.rowsPerPage)}
                    page={tableData.page}
                    onPageChange={(event, newPage) => setTableData((prev) => ({...prev, page: newPage}))}
                    onRowsPerPageChange={(event) => {
                        setTableData((prev) => ({...prev, rowsPerPage: event.target.value, page: 0}))
                        localStorage.setItem(LOCAL_STORAGE_ITEM_NAME, event.target.value)
                    }}
                    labelRowsPerPage="Elemek oldalanként:"
                />
            </Paper>

            <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        const formData = new FormData(event.currentTarget);
                        const formJson = Object.fromEntries((formData).entries());
                        if (isNewFilter) createNewFilter(formJson.name)
                        else updateFilter(formJson.name)
                        handleClose();
                    },
                }}
            >
                <DialogTitle sx={{backgroundColor: "#1976d2", color: "white"}}>Add meg a szűrő nevét</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        name="name"
                        label="Név"
                        fullWidth
                        defaultValue={filters[selectedIndex]?.name}
                        variant="standard"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} sx={{marginRight: "auto"}} color="error"
                            variant="outlined">Mégse</Button>
                    <Button type="submit" variant="contained">Mentés</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openNotificationDetails}
                onClose={handleCloseTaskDetails}
                sx={{"& form": {borderRadius: "15px"}}}
            >
                <DialogTitle sx={{backgroundColor: "#1976d2", color: "white", textAlign: "center"}}>Részletek</DialogTitle>
                {getNotificationDetails()}
            </Dialog>
        </div>
    )
}
